export interface IAopSelectedAccountPrintPreviewMappingValue {
    openingValue: number | null;
    closingValue: number | null;
}
